import {
  QBankStructureLevelCategory,
  TagCategory,
  type GetQuestionsByIdAndQuestionCreationTaskIdQuery,
} from '@exam-management/graphql';

const FALLBACK_LEVEL_NAME = 'ไม่ระบุ';

const DIFFICULTY_MAP = {
  ง่าย: 'easy',
  กลาง: 'normal',
  ยาก: 'hard',
} as const;

export default function transformQuestionsToQuestionRows(
  questions: GetQuestionsByIdAndQuestionCreationTaskIdQuery['qctGetTaskQuestionsByIds'] = [],
) {
  return questions.map((question, index) => {
    const { chapterName, topicName, subTopicName } = (question.questionStructures ?? []).reduce(
      (acc, cur) => {
        const levelItem = cur.levelItem;
        const qBankStructureLevel = levelItem?.qBankStructureLevel;
        const tag = levelItem?.tag;

        if (qBankStructureLevel?.category === QBankStructureLevelCategory.Chapter) {
          acc.chapterName = tag?.name ?? FALLBACK_LEVEL_NAME;
        }
        if (qBankStructureLevel?.category === QBankStructureLevelCategory.Topic) {
          acc.topicName = tag?.name ?? FALLBACK_LEVEL_NAME;
        }
        if (qBankStructureLevel?.category === QBankStructureLevelCategory.SubTopic) {
          acc.subTopicName = tag?.name ?? FALLBACK_LEVEL_NAME;
        }

        return acc;
      },
      {
        chapterName: FALLBACK_LEVEL_NAME,
        topicName: FALLBACK_LEVEL_NAME,
        subTopicName: FALLBACK_LEVEL_NAME,
      },
    );

    const { difficulty, calculation } = question.tags.reduce(
      (acc, cur) => {
        const name = cur?.name;
        const category = cur.category;

        if (category === TagCategory.Difficulty) {
          acc.difficulty = DIFFICULTY_MAP[name as keyof typeof DIFFICULTY_MAP] ?? 'easy';
        }

        if (category === TagCategory.Calculation) {
          acc.calculation = name ?? '';
        }
        return acc;
      },
      { difficulty: '', calculation: '' },
    );
    return {
      id: question.id,
      order: index + 1,
      chapterName,
      topicName,
      subTopicName,
      difficulty,
      calculation,
      questionGroupType: question.questionGroup?.type,
    };
  });
}
